"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacySummary = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
const PrivacySection_1 = require("../PrivacySection/PrivacySection");
function PrivacySummary() {
    const { t } = (0, i18n_1.useTranslation)();
    const bridge = (0, bridge_1.useBridge)();
    const sections = Object.entries(t(i18n_1.Strings.firstLaunchOnboarding.privacy.sections.toString(), {
        returnObjects: true,
    }));
    const privacyPolicyLink = t(i18n_1.Strings.firstLaunchOnboarding.privacy.policyURL);
    const termsOfUseLink = t(i18n_1.Strings.firstLaunchOnboarding.privacy.termsOfUseURL);
    const thirdPartyLink = t(i18n_1.Strings.firstLaunchOnboarding.privacy.sections.thirdParties.hintURL);
    const onLinkClick = (link) => {
        bridge === null || bridge === void 0 ? void 0 : bridge.openWebView({ url: link });
    };
    const renderSections = (start, end) => {
        return sections
            .slice(start, end)
            .map(([key, translations]) => ((0, react_1.createElement)(PrivacySection_1.PrivacySection, Object.assign({}, translations, { options: translations.options, key: key, "data-e2e": 'PrivacySummary_PrivacySection' }))));
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'PrivacySummary_Container', children: [(0, jsx_runtime_1.jsx)(Heading, { "data-e2e": 'PrivacySummary_Heading', children: t(i18n_1.Strings.firstLaunchOnboarding.privacy.heading) }), (0, jsx_runtime_1.jsx)(Subheading, { "data-e2e": 'PrivacySummary_Subheading', children: t(i18n_1.Strings.firstLaunchOnboarding.privacy.subheading) }), (0, jsx_runtime_1.jsx)(StyledScrollView, { "data-e2e": 'PrivacySummary_StyledScrollView', children: (0, jsx_runtime_1.jsxs)(Row, { "data-e2e": 'PrivacySummary_Row', children: [(0, jsx_runtime_1.jsx)(Column, { "data-e2e": 'PrivacySummary_Column', children: renderSections(0, 4) }), (0, jsx_runtime_1.jsxs)(Column, { "data-e2e": 'PrivacySummary_Column', children: [renderSections(4), (0, jsx_runtime_1.jsx)(Links, { "data-e2e": 'PrivacySummary_Links', children: (0, jsx_runtime_1.jsxs)(i18n_1.Trans, { i18nKey: i18n_1.Strings.firstLaunchOnboarding.privacy.links, "data-e2e": 'PrivacySummary_Trans', children: ["See full", (0, jsx_runtime_1.jsxs)(LinkButton, { size: ui_1.ButtonSize.Small, onClick: () => onLinkClick(privacyPolicyLink), "data-e2e": 'PrivacySummary_LinkButton', children: [' ', "Privacy Policy", ' '] }), ",", (0, jsx_runtime_1.jsxs)(LinkButton, { size: ui_1.ButtonSize.Small, onClick: () => onLinkClick(termsOfUseLink), "data-e2e": 'PrivacySummary_LinkButton', children: [' ', "Terms of Use"] }), "and", (0, jsx_runtime_1.jsxs)(LinkButton, { size: ui_1.ButtonSize.Small, onClick: () => onLinkClick(thirdPartyLink), "data-e2e": 'PrivacySummary_LinkButton', children: [' ', "Third Party SDK's"] })] }) })] })] }) })] }));
}
exports.PrivacySummary = PrivacySummary;
const Container = styled_components_1.default.div `
  height: 100%;
  flex-wrap: wrap;
`;
const Heading = styled_components_1.default.h1 `
  margin: 0;
  padding-top: 24px;

  color: ${({ theme }) => theme.text};
  font-weight: 400;
  font-size: 34px;
  line-height: 1.18;
  text-align: center;

  ${ui_1.device.mobileS `
    padding: 0px 40px;
    font-size: 30px;
  `}
`;
const Subheading = styled_components_1.default.h2 `
  margin: 15px 20px;
  color: #dfe0e1;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  text-align: center;

  ${ui_1.device.mobileS `
    padding: 0px 10px;
  `}
`;
const StyledScrollView = styled_components_1.default.div `
  display: flex;
  height: calc(100% - 88px);
  margin: 0 auto;
  justify-content: center;

  ${ui_1.device.laptop `
    margin-right: -32px;
  `}
`;
const Row = styled_components_1.default.div `
  display: block;

  max-width: 440px;
  margin: 0 auto;

  padding-bottom: 120px;

  ${ui_1.device.mobileM `
    display: flex;
    flex-flow: column nowrap;

    justify-content: space-evenly;

    max-width: unset;
    margin: unset;
  `}

  ${ui_1.device.laptop `
    display: flex;
    flex-flow: row wrap;

    justify-content: space-around;
    max-width: 100%;
  `}

  ${ui_1.devicePortrait.all `
    padding-bottom: 176px;
  `}
`;
const Column = styled_components_1.default.div `
  display: flex;
  flex-flow: column nowrap;
  margin: 0 auto;
`;
const Links = styled_components_1.default.div `
  margin-top: 20px;
  margin-left: 40px;
  width: 80%;

  color: #dfe0e1;
  font-size: 14px;
`;
const LinkButton = (0, styled_components_1.default)(ui_1.FlatButton) `
  margin: 0;
  padding: 0;

  color: ${({ theme }) => theme.userOnboarding.primaryButton.enabled.background};
  font-family: 'Main CA Font', sans-serif;
`;
